export const TYPES_OPTIONS = [
  { label: "Integer", value: "INT" },
  { label: "Double", value: "DOUBLE" },
  { label: "Long", value: "LONG" },
  { label: "Boolean", value: "BOOLEAN" },
  { label: "Date Time", value: "DATETIME" },
  { label: "Date", value: "DATE" },
  { label: "String", value: "STRING" },
  { label: "Array of Object", value: "ARRAYOFOBJ" },
  { label: "Size of Array", value: "SIZEOFARRAY" },
  { label: "UUID", value: "UUID" },
  { label: "Json List", value: "JSON_LIST" },
  { label: "Object", value: "OBJECT" },
  { label: "Collection Object", value: "COLLECTION_OBJECT" },
  { label: "Collection Object List", value: "COLLECTION_OBJECT_LIST" },
  { label: "ENUM", value: "ENUM" },
];

export const TABLE_ATTRIBUTE_TYPES = {
  INTEGER: "INT",
  DOUBLE: "DOUBLE",
  LONG: "LONG",
  BOOLEAN: "BOOLEAN",
  STRING: "STRING",
  ARRAYOFOBJ: "ARRAYOFOBJ",
  SIZEOFARRAY: "SIZEOFARRAY",
  UUID: "UUID",
  JSON_LIST: "JSON_LIST",
  COLLECTION_OBJECT: "COLLECTION_OBJECT",
  COLLECTION_OBJECT_LIST: "COLLECTION_OBJECT_LIST",
  ENUM: "ENUM",
  DATE: "DATE",
  DATETIME: "DATETIME",
  TIME: "TIME",
  FILE_URL: "FILE_URL",
};

export const TYPES = {
  STRING: "text",
  UUID: "text",
  DATE: "text",
  TIME: "text",
  DATETIME: "text",
  FILE_URL: "text",

  INT: "number",
  DOUBLE: "number",
  LONG: "number",

  BOOLEAN: "radio",

  ARRAYOFOBJ: "textarea",
  SIZEOFARRAY: "textarea",
  JSON_LIST: "textarea",

  ENUM: "select",
  COLLECTION_OBJECT: "select",
  COLLECTION_OBJECT_LIST: "select",
};

export const TEXT_TYPES = [
  "STRING",
  "UUID",
  "DATE",
  "TIME",
  "DATETIME",
  "FILE_URL",
];

export const NUMBER_TYPES = ["INT", "DOUBLE", "LONG"];

export const RADIO_TYPES = ["BOOLEAN"];

export const TEXTAREA_TYPES = ["ARRAYOFOBJ", "SIZEOFARRAY", "JSON_LIST"];

export const SELECT_TYPES = ["ENUM", "COLLECTION_OBJECT", "COLLECTION_OBJECT_LIST"];
